/*@ngInject*/
export default ['MsisdnsService', '$q', 'ASYNC_VALIDATOR_DEBOUNCE', (MsisdnsService, $q, ASYNC_VALIDATOR_DEBOUNCE) => ({
    restrict: 'A',
    require: 'ngModel',
    link: (scope, elm, attrs, ctrl) => {
        ctrl.$asyncValidators.unique = (modelValue) => {
            ctrl.$options.$$options.updateOn = 'default blur';
            ctrl.$options.$$options.debounce = {default: ASYNC_VALIDATOR_DEBOUNCE, blur: 0};
            let def = $q.defer();
          MsisdnsService.existsLabel({label: modelValue},
                (res) => {
                    if (!res.data || attrs.initialValue === modelValue) {
                        def.resolve(res.data);
                    } else {
                        def.reject(res.data);
                    }
                });
            return def.promise;
        };
    }
})];
